/**
 * Dispatches a DOM event to the ProseMirror editor view's event handlers.
 * This function is used to manually trigger DOM event handling in the editor,
 * particularly when you need to simulate or forward events from outside the editor.
 *
 * The function looks up any registered handlers for the event type in the editor's
 * handleDOMEvents property and calls them if found. This is commonly used for
 * handling focus, blur, and other DOM events that need to be managed by the editor.
 */
export const dispatchEditorViewEvent = (view, event) => {
    view.someProp("handleDOMEvents", (handlers) => {
        const handler = handlers[event.type];
        if (handler) {
            handler(view, event);
        }
    });
};
